/**
 * JINS Cheek Color Lens - US Landing Page
 * Version: 1.0
 * Last Updated: 2026-01-21
 */

(function() {
  // Color Switcher Functionality
  var switchItems = document.querySelectorAll('.cheekcolor-lp .colorcontrol__doboz__switch__item');
  var mainItems = document.querySelectorAll('.cheekcolor-lp .colorcontrol__doboz__main__item');
  
  switchItems.forEach(function(item, index) {
    item.addEventListener('click', function() {
      // Flash effect on switch
      item.classList.add('is-flashing');
      setTimeout(function() {
        item.classList.remove('is-flashing');
      }, 80);

      // Flash effect on main image
      mainItems[index].classList.add('is-flashing');
      setTimeout(function() {
        mainItems[index].classList.remove('is-flashing');
      }, 80);

      // Remove active from all switches
      switchItems.forEach(function(s) { s.classList.remove('is-active'); });
      // Add active to clicked
      item.classList.add('is-active');
      
      // Hide all main items
      mainItems.forEach(function(m) { m.classList.remove('is-active'); });
      // Show corresponding main item
      mainItems[index].classList.add('is-active');
    });
  });
})();
